import { gql } from '@apollo/client';

export const COPY_SETTINGS = gql`
  mutation CopySettings($copySettingsId: Int!) {
    copySettings(id: $copySettingsId)
  }
`;
